module.exports = __webpack_public_path__ + "img/9.256f34fe.png";